import { useLocaleState, useTranslate } from "ra-core";

import type { ProjectEvent } from "../types";
import { formatBudget, phaseKey, roleKey } from "./projectUtils";

/** Libellé et texte d'un changement de l'historique, partagés par l'historique de la fiche et les alertes. */
export const useEventText = () => {
  const translate = useTranslate();
  const [locale] = useLocaleState();

  const label = (field: string) =>
    field.startsWith("company:")
      ? translate(roleKey(field.replace("company:", "")), {
          _: field.replace("company:", ""),
        })
      : translate(`resources.projects.fields.${field}`);
  const display = (field: string, value: string) => {
    if (field === "phase" || field === "phase_contradiction")
      return translate(phaseKey(value), { _: value });
    if (field === "budget_amount") {
      // Écrit « montant devise », comme dans les preuves.
      const [amount, currency] = value.split(" ");
      return formatBudget(
        { budget_amount: Number(amount), budget_currency: currency },
        locale,
      );
    }
    return value;
  };
  const change = (
    event: Pick<ProjectEvent, "field" | "old_value" | "new_value">,
  ) =>
    event.field === "phase_contradiction"
      ? translate("resources.projects.history.contradiction", {
          old: display(event.field, event.old_value ?? ""),
          new: display(event.field, event.new_value),
        })
      : event.old_value
        ? translate("resources.projects.history.changed", {
            old: display(event.field, event.old_value),
            new: display(event.field, event.new_value),
          })
        : translate("resources.projects.history.added", {
            new: display(event.field, event.new_value),
          });

  return { label, change };
};
